<div class="grid">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoListar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoListar">
			<div class="formgroup" *ngIf="permissaoInserir">
				<div class="p-fluid p-formgrid grid">
					<div class="field col-12 md:col-2">
						<button pButton pRipple routerLink="/apps/contrato/inserir" label="Novo" icon="pi pi-plus"
							class="p-button-outlined sm:w-9rem"></button>
					</div>
				</div>
			</div>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="contratos" dataKey="id" [rows]="10" [loading]="loadingContratos" [rowHover]="true"
				[paginator]="true" [globalFilterFields]="['razaoSocial', 'cnpj']" responsiveLayout="stack"
				styleClass=" p-datatable-sm">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<p-dropdown class="p-fluid sm:mr-2" [options]="situacoesStatus" optionLabel="label"
							optionValue="value" emptyFilterMessage="Nenhum registro"
							[(ngModel)]="statusSelecionado"
							(ngModelChange)="listarContratos()">
						</p-dropdown>

						<div class="p-fluid mt-2 sm:mt-0">
							<div class="flex">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" #filter (input)="buscar(dt1, $event)"
										placeholder="Buscar" class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
								</span>
							</div>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="razaoSocial">
							Razão Social
							<p-sortIcon field="razaoSocial">
							</p-sortIcon>
						</th>
						<th pSortableColumn="cnpj">
							CNPJ
							<p-sortIcon field="cnpj">
							</p-sortIcon>
						</th>
						<th pSortableColumn="status">
							Status
							<p-sortIcon field="status">
							</p-sortIcon>
						</th>
						<th style="text-align: center;">
							<div>
								Ações
							</div>
						</th>

					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-contrato>
					<tr>
						<td>
							{{ contrato.razaoSocial }}
						</td>
						<td>
							{{ contrato.cnpj | cnpjFormat }}
						</td>
						<td>
							<span class="product-badge status-instock" *ngIf="contrato.ativoContratante">ATIVO</span>
							<span class="product-badge status-outofstock" *ngIf="!contrato.ativoContratante">INATIVO</span>
						</td>

						<td style="text-align: center;">
							<div>
								<button *ngIf="permissaoDetalhar" pButton pRipple pTooltip="Detalhar"
									(click)="detalharContrato(contrato.id)" icon="pi pi-eye"
									class="p-button-info mr-2 mb-2"></button>
								<button *ngIf="permissaoEditar" pButton pRipple pTooltip="Editar"
									(click)="editarContrato(contrato.id)" icon="pi pi-pencil"
									class="p-button-success mr-2 mb-2"></button>
								<button *ngIf="permissaoExcluir" pButton pRipple pTooltip="Excluir" icon="pi pi-trash"
									(click)="excluir(contrato.id)" class="p-button-danger mr-2 mb-2 sm"></button>

							</div>
						</td>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando contratos. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
			<p-confirmDialog [style]="{width: '50vw'}">
			</p-confirmDialog>
		</div>
	</div>
</div>